import { defineStore } from 'pinia'

interface ConfirmState {
  isOpen: boolean
  header: string
  message: string
  resolve: ((value: boolean) => void) | null
}

export const useConfirmStore = defineStore('confirm', {
  state: (): ConfirmState => ({
    isOpen: false,
    header: '',
    message: '',
    resolve: null,
  }),
  actions: {
    open(header: string, message: string): Promise<boolean> {
      this.resolve?.(false)

      this.isOpen = true
      this.header = header
      this.message = message

      return new Promise((resolve) => {
        this.resolve = resolve
      })
    },
    confirm() {
      this.resolve?.(true)
      this.close()
    },
    cancel() {
      this.resolve?.(false)
      this.close()
    },
    close() {
      this.isOpen = false
      this.resolve = null
    },
  },
})

export function useConfirm() {
  const store = useConfirmStore()

  function confirm(header: string, message: string): Promise<boolean> {
    return store.open(header, message)
  }

  return { confirm }
}
